// src/App.tsx - VERSIÓN LIMPIA
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

// Contextos
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';

// Componente principal de rutas
import AppContent from './components/AppContent';
import './index.css';
import { useFingerprintSync } from './hooks/useFingerprintSync';

// Componente principal App
const App: React.FC = () => {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router basename={process.env.PUBLIC_URL} future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <AppContent />
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;